const employerToJobState = {
    NOT_SENT: -1,
    SENT: 0,
    WATCHED: 1,
    EMPLOYER_WILL_CONTACT: 2,
    CANDIDATE_DOES_NOT_MATCH: 3,
    PROCESS_COMPLETED: 4,
    // Value 5 is reserved for a legacy completed-process state.
    ADVANCED_PROCESS: 6,
} as const;

const employerStateTransitions: Record<number, readonly number[]> = {
    [employerToJobState.NOT_SENT]: [
        employerToJobState.EMPLOYER_WILL_CONTACT,
        employerToJobState.CANDIDATE_DOES_NOT_MATCH,
    ],
    [employerToJobState.SENT]: [
        employerToJobState.EMPLOYER_WILL_CONTACT,
        employerToJobState.CANDIDATE_DOES_NOT_MATCH,
    ],
    [employerToJobState.WATCHED]: [
        employerToJobState.EMPLOYER_WILL_CONTACT,
        employerToJobState.CANDIDATE_DOES_NOT_MATCH,
    ],
    [employerToJobState.EMPLOYER_WILL_CONTACT]: [
        employerToJobState.ADVANCED_PROCESS,
        employerToJobState.PROCESS_COMPLETED,
    ],
    [employerToJobState.ADVANCED_PROCESS]: [employerToJobState.PROCESS_COMPLETED],
    [employerToJobState.CANDIDATE_DOES_NOT_MATCH]: [employerToJobState.EMPLOYER_WILL_CONTACT],
};

export function isEmployerStateTransitionAllowed(currentState: number, nextState: number): boolean {
    return employerStateTransitions[currentState]?.includes(nextState) ?? false;
}

export function isEmployerProcessCompleted(state: number): boolean {
    return state >= employerToJobState.PROCESS_COMPLETED && state !== employerToJobState.ADVANCED_PROCESS;
}

export default employerToJobState;
